import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { playSoundEffect } from '../hooks/useSoundEffects';
import './NotificationToast.css';

/**
 * NotificationToast Component
 * Replaces native alert() with a styled toast notification
 * Auto-dismisses after a few seconds
 */
const NotificationToast = ({ message, type = 'info', onClose, duration = 4000 }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    // Play sound effect
    playSoundEffect('/sounds/click.mp3', 0.3);

    // Auto-dismiss after duration
    const timer = setTimeout(() => {
      setIsAnimating(true);
      setTimeout(() => {
        setIsVisible(false);
        if (onClose) onClose();
      }, 300); // Match animation duration
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const handleClose = () => {
    setIsAnimating(true);
    setTimeout(() => {
      setIsVisible(false);
      if (onClose) onClose();
    }, 300);
  };

  if (!isVisible) return null;

  const typeClass = `notification-toast-${type}`;

  return createPortal(
    <div 
      className={`notification-toast ${typeClass} ${isAnimating ? 'notification-toast-exit' : ''}`}
      onClick={handleClose}
    >
      <div className="notification-toast-content">
        <span className="notification-toast-message">{message}</span>
        <button 
          className="notification-toast-close"
          onClick={(e) => {
            e.stopPropagation();
            handleClose();
          }}
          aria-label="Close"
        >
          ×
        </button>
      </div>
    </div>,
    document.body
  );
};

export default NotificationToast;

